export default __webpack_public_path__ + "static/media/pibox_logo_wht.75085307.png";